"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var Spinner = /** @class */ (function (_super) {
    tslib_1.__extends(Spinner, _super);
    function Spinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.classNames = function () { return classNames('loading-component', _this.props.size); };
        _this.getWings = function () {
            var wings = [];
            var wingCount = _this.props.size === 'small' ? 3 : 5;
            var color = (_this.props.color) ? { backgroundColor: _this.props.color } : null;
            for (var i = 0; i < wingCount; i++) {
                var wing = {
                    classNames: "rect rect" + (i + 1),
                    style: color,
                };
                wings.push(wing);
            }
            return wings;
        };
        return _this;
    }
    Spinner.prototype.render = function () {
        return (React.createElement("div", { className: this.classNames() }, this.getWings().map(function (wing, index) { return React.createElement("div", { key: index, className: wing.classNames, style: wing.style }); })));
    };
    return Spinner;
}(React.Component));
exports.default = Spinner;
//# sourceMappingURL=spinner.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/spinner.js
// module id = GSye
// module chunks = 20 21